import { ISettings } from '@admin/pages/settings-manager/interfaces/settings.interface';
import { Injectable } from '@angular/core';
import { ApiService } from '@core/services/api.service';
import { ApiServiceHolder } from '@core/utils/api-service-holder';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ICountry } from '@shared/interfaces/country.interface';
import { IKeyValue, IPaymentType } from '@shared/interfaces/key-value.interface';
import { Observable } from 'rxjs';
import { DefaultPriceRange } from 'src/app/articles-manager/interfaces/auction.interface';

@Injectable({
  providedIn: 'root'
})
@UntilDestroy()
export class PublicGenericService {
  appCountryList: ICountry[] = [];
  auctionDetailList: IKeyValue[] = [];
  priceRangeList: DefaultPriceRange[] = [];

  constructor(private _api: ApiService) { }

  getGlobalSettings(): Observable<ISettings> {
    return this._api.request(ApiServiceHolder.publicGeneric.getGlobalSettings());
  }

  getAllCountries() {
    this._api.request<ICountry[]>(ApiServiceHolder.publicGeneric.getAllCountries()).pipe(untilDestroyed(this)).subscribe((dataR) => {
      this.appCountryList = dataR;
    });
  }

  getAllIdentificationCardTypes(): Observable<IKeyValue[]> {
    return this._api.request(ApiServiceHolder.publicGeneric.getAllIdentificationCardTypes());
  }

  getAllEntityTypes(): Observable<IKeyValue[]> {
    return this._api.request(ApiServiceHolder.publicGeneric.getAllEntityTypes());
  }

  getAllAddressType(): Observable<IKeyValue[]> {
    return this._api.request(ApiServiceHolder.publicGeneric.getAllAddressType());
  }

  getAllDetails() {
    this._api.request<IKeyValue[]>(ApiServiceHolder.publicGeneric.getAllDetails()).pipe(untilDestroyed(this)).subscribe((dataR) => {
      this.auctionDetailList = dataR;
    });
  }

  getPriceRange() {
    this._api.request<DefaultPriceRange[]>(ApiServiceHolder.publicGeneric.getPriceRange()).pipe(untilDestroyed(this)).subscribe((dataR) => {
      this.priceRangeList = dataR;
    });
  }

  getAllArticleCategories(): Observable<IKeyValue[]> {
    return this._api.request(ApiServiceHolder.publicGeneric.getAllArticleCategories());
  }

  GetAllEmailSubjects(): Observable<IKeyValue[]> {
    return this._api.request(ApiServiceHolder.publicGeneric.GetAllEmailSubjects());
  }

  getSports(onlyUsed: boolean): Observable<IKeyValue[]> {
    return this._api.request(ApiServiceHolder.publicGeneric.getSports(onlyUsed));
  }

  getCompetitions(idSport: number, onlyUsed: boolean): Observable<IKeyValue[]> {
    return this._api.request(ApiServiceHolder.publicGeneric.getCompetitions(idSport, onlyUsed));
  }

  getTeams(idSport: number, onlyUsed: boolean): Observable<IKeyValue[]> {
    return this._api.request(ApiServiceHolder.publicGeneric.getTeams(idSport, onlyUsed));
  }

  getAllPaymentTypes(): Observable<IKeyValue[]> {
    return this._api.request(ApiServiceHolder.publicGeneric.getAllPaymentTypes());
  }

  getAllDetailedPaymentTypes(): Observable<IPaymentType[]> {
    return this._api.request(ApiServiceHolder.publicGeneric.getAllDetailedPaymentTypes());
  }
}
